import API from "../api";

export const logger = payload =>
  API.base().post(`/eapi/react-logging/v2/log`, payload);

export const logUserInteraction = payload =>
  API.url(window.env.REACT_APP_AWS_USER_INTERACTIONS).put(`/record`, payload);
